import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * 合併 Tailwind 類名，自動處理衝突
 * @example cn('px-2', 'px-4') // → 'px-4'
 * @example cn('flex', isActive && 'bg-blue-500') // → 'flex bg-blue-500' or 'flex'
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

// Re-export ClassValue for external use
export type { ClassValue };
